<template>
  <div>
    <!-- title -->

    <span
      ><b>{{ employee.firstName }} {{ employee.lastName }}</b></span
    >
    <!-- Table -->
    <div>
      <vue-table-dynamic :params="params" @cell-click="tableCellClicked">
      </vue-table-dynamic>
    </div>
  </div>
</template>

<script>
import VueTableDynamic from "vue-table-dynamic";

import ReportService from "../../services/report.service";

import {
  getMonthNameFromId,
  // getStatusCodeFromStatusId,
} from "../../_helpers/arrangers";

export default {
  name: "MonthlyStatusTable",

  props: {
    employee: Object,
    month: Number,
    year: Number,
  },

  components: {
    VueTableDynamic,
  },
  data() {
    return {
      params: {
        data: [
          [
            "Mjesec",
            "Na poslu",
            "Bolovanje",
            "Godišnji odmor",
            "Slobod. nerad. dan",
            "Slobod. radni dan",
            "Neplaćeno odsustvo",
            "Plaćeno odsustvo",
            "Službeni put",
            "Praznik",
            "Ukup radnih dana",
            "Ukup neradnih dana",
            "Ukup dana mjesec",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [{ column: 0, width: "7%" }],
        wordWrap: "break-word",
        whiteSpace: "normal",
      },
      dataMonth: "Januar",
      dataPlus: 0,
      dataBO: 0,
      dataGO: 0,
      dataSN: 0,
      dataSR: 0,
      dataNO: 0,
      dataPO: 0,
      dataSO: 0,
      dataPR: 0,
      dataWorkdaysTotal: 0,
      dataNonworkdaysTotal: 0,
      dataDaysInMonth: 31,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    resetUi() {
      this.dataMonth = "Januar";
      this.dataPlus = 0;
      this.dataBO = 0;
      this.dataGO = 0;
      this.dataSN = 0;
      this.dataSR = 0;
      this.dataNO = 0;
      this.dataPO = 0;
      this.dataSO = 0;
      this.dataPR = 0;
      this.dataWorkdaysTotal = 0;
      this.dataNonworkdaysTotal = 0;
      this.dataDaysInMonth = 31;
    },
    tableCellClicked() {},
    getData() {
      this.resetUi();
      ReportService.GetMonthlyPresenceReviewByEmployeeIdAndMonth(
        this.employee.employeeId,
        this.month,
        this.year
      ).then((response) => {
        // console.log(response.data);

        response.data.forEach((element) => {
          this.calculate(element);
        });

        this.params.data.push([
          this.dataMonth,
          this.dataPlus,
          this.dataBO,
          this.dataGO,
          this.dataSN,
          this.dataSR,
          this.dataNO,
          this.dataPO,
          this.dataSO,
          this.dataPR,
          this.dataWorkdaysTotal,
          this.dataNonworkdaysTotal,
          this.dataDaysInMonth,
        ]);
      });
    },
    calculate(element) {
      this.dataMonth = getMonthNameFromId(this.month);
      if (element.statusId == 1) {
        this.dataPlus++;
      } else if (element.statusId == 2) {
        this.dataGO++;
      } else if (element.statusId == 3) {
        this.dataBO++;
      } else if (element.statusId == 4) {
        this.dataSO++;
      } else if (element.statusId == 5) {
        this.dataPO++;
      } else if (element.statusId == 6) {
        this.dataPR++;
      } else if (element.statusId == 7) {
        this.dataNO++;
      } else if (element.statusId == 8) {
        this.dataSN++;
      } else if (element.statusId == 9) {
        this.dataSR++;
        // } else if (element.statusId == 10) {
        //   this.dataTB++;
      }
      // console.log(element);
      // console.log(this.dataMonth);
    },
  },
};
</script>

<style scoped>
.base-demo {
  width: 1550px;
  white-space: nowrap;
}

.small {
  font-size: 10px;
}

.base-demo >>> .v-table-row.is-header {
  /* background: red !important; */
  /* border-top: 1px solid red !important; */
  /* border-right: 1px solid red !important; */
  border-bottom: 1px solid red !important;
}
.base-demo >>> .table-cell {
  /* border-left: 1px solid red !important; */
  padding: 1px !important;
  /* flex: 0 0 30px !important; */
}
.base-demo >>> .table-cell-content {
  /* border-left: 1px solid red !important; */
  /* margin: 0px -10px 0px -10px !important; */
  padding: 10px !important;
  /* flex: 0 0 0 0px !important; */
}
</style>